import { render, staticRenderFns } from "./BaseListCardItemLoader.vue?vue&type=template&id=9924293e"
import script from "./BaseListCardItemLoader.vue?vue&type=script&lang=js"
export * from "./BaseListCardItemLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports